/* General Styles */

export const btnStyle =
  "px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 block";

export const containerStyle = "px-8 pt-24 pb-14";

export const transitionStyle = "transition ease-in-out delay-150 duration-300";

/* Navbar */
export const navBar =
  "flex justify-between body-bg z-20 fixed px-5 items-center body-bg rounded-lg mx-4 my-2 h-[60px]";

export const navList = `${transitionStyle} absolute ml:relative body-bg z-[-10] w-full h-max shadow-md shadow-[#000] ml:shadow-none left-0 ml:left-auto ml:translate-y-0`;

export const navItem: string = `${transitionStyle} nav__item px-2 py-4 md:mr-5 font-semibold hover:border-[#576ee0] hover:border-b-2 cursor-pointer block w-full ml:text-sm active:border-[#576ee0] active:border-b-2`;

/* Home */

export const homeImage =
  "w-[230px] h-[230px] ml:w-[260px] ml:h-[260px] border overflow-hidden md:order-last rounded-[15px] bg-gradient-radial from-[#333333] via-[#0e0e0e] to-[#0e0e0e]";

/* Contact */

export const formContent = "rounded px-3 py-2 my-5 container-bg";
export const inputLabel = "text-sm text-gray-600 flex flex-col";
export const formInput =
  "w-full min-w-[300px] container-bg py-2 border-none outline-none mt-2 text-white";
